<!--
 * @Description:

 * @Date: 2018-12-21 17:03:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-26 16:01:27
 -->
<template>
  <div class="revise-password">
    <modal-base
      :title="diaLogTitle(nowStep)"
      :back="false"
      @callback="callback"
      :hideBtn="hideBtn"
      :confirmText="confirmText"
    >
      <div class="revise-password-dialog-body" slot="content">
        <el-form
          class="revise-password-form"
          :model="modelForm[nowStep]"
          status-icon
          ref="ruleForm"
          v-if="nowStep < 2"
        >
          <el-form-item
            :prop="item.key"
            v-for="(item, index) in form[nowStep]"
            :key="`form-${index}`"
            :rules="item.rule"
          >
            <el-input
              :prefix-icon="item.icon"
              class="input"
              clearable
              :type="item.type"
              v-model="modelForm[nowStep][item.key]"
              autocomplete="off"
              :placeholder="item.placeholder"
            >
              <template slot="append" v-if="item.slot == 'imgYzm' && phoneIsOk">
                <div class="yzm-img">
                  <img :src="imgUrl" class="imgVerify" />
                </div>
              </template>
              <template
                slot="append"
                v-if="item.slot == 'sendMsg' && phoneIsOk"
              >
                <div class="send-msg">
                  <msgCode
                    :phone="modelForm[nowStep]['phone']"
                    :imgCode="modelForm[nowStep]['captcha']"
                    :getMsgCodeFn="ajaxSendMsgCode"
                    @error="changeEwm"
                  ></msgCode>
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <div v-else class="revise-success">
          <img
            class="icon"
            src="data:image/jpeg;base64,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"
            alt
          />
          <div class="text">密码修改成功</div>
          <div class="tips">请重新登录，{{ time }}s</div>
        </div>
      </div>
    </modal-base>
  </div>
</template>

<script>
import modalBase from './modalBase.vue';
import { login } from '@/api/ajax';
import msgCode from '@/components/Common/msgCode.vue';
const normalValidator = (rule, value, callback, errTip) => {
  if (`${value}`.length == 0) {
    callback(new Error(errTip));
  } else {
    callback();
  }
};
export default {
  components: { msgCode, modalBase },
  props: {
    ajaxGetMsgCode: {
      type: Function
      // default: login.sendMessageCode
    },
    ajaxGetImgCode: {
      type: [Function, String],
      default: login.verifyImgCode
    }
  },
  data() {
    return {
      nowStep: 0,
      showDialog: true,
      formAllData: [
        {
          step: 0,
          label: '手机号码',
          placeholder: '请输入手机号码',
          key: 'phone',
          type: '',
          val: '',
          icon: 'el-icon-mobile-phone',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (!/^1\d{10}$/.test(value)) {
                  `${value}`.length == 0
                    ? callback(new Error('手机号码不能为空'))
                    : callback(new Error('请输入正确的手机号'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            },
            {
              required: true,
              validator: (rule, value, callback) => {
                if (/^1\d{10}$/.test(value)) {
                  this.changeEwm(value);
                  this.phoneIsOk = true;
                  callback();
                } else {
                  this.phoneIsOk = false;
                }
              },
              trigger: 'change'
            }
          ]
        },
        {
          step: 0,
          label: '图形验证码',
          placeholder: '请输入图形验证码',
          key: 'captcha',
          val: '',
          slot: 'imgYzm',
          icon: 'el-icon-picture-outline',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (`${value}`.length < 4) {
                  callback(new Error('图形验证码不能小于4位'));
                } else {
                  callback();
                }
              },
              trigger: 'blur'
            }
          ]
        },
        {
          step: 0,
          label: '短信验证码',
          placeholder: '请输入短信验证码',
          key: 'code',
          val: '',
          slot: 'sendMsg',
          icon: 'el-icon-message',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                normalValidator(rule, value, callback, '短信验证码不能为空');
              },
              trigger: 'blur'
            }
          ]
        },
        {
          step: 1,
          label: '重置密码',
          type: 'password',
          placeholder: '请输入密码',
          key: 'pwd',
          icon: 'el-icon-lock',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (`${value}`.length == 0) {
                  callback(new Error('密码不能为空'));
                } else if (
                  !/^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{4,16}$/.test(value)
                ) {
                  callback(new Error('密码只能使用数字和字母组合,4到16位'));
                }
              },
              trigger: 'blur'
            }
          ],
          val: ''
        },
        {
          step: 1,
          label: '确认密码',
          type: 'password',
          placeholder: '请再次输入密码',
          key: 'pwd_sure',
          icon: 'el-icon-lock',
          rule: [
            {
              required: true,
              validator: (rule, value, callback) => {
                if (`${value}`.length == 0) {
                  callback(new Error('密码不能为空'));
                }
                if (value != this.modelForm[this.nowStep]['pwd']) {
                  callback(new Error('两次输入密码不一样'));
                }
                callback();
              },
              trigger: 'blur'
            }
          ],
          val: ''
        }
      ],
      steps: [
        {
          title: '验证手机号',
          nextBtn: {
            text: '下一步',
            fn: () => {
              this.nextStep();
            }
          },
          description: ''
        },
        {
          title: '重置密码',
          nextBtn: {
            text: '下一步',
            fn: () => {
              this.nextStep();
              this.reviseSuccess();
            }
          },
          description: ''
        },
        {
          title: '修改成功',
          nextBtn: null,
          description: ''
        }
      ],
      form: [],
      modelForm: [],
      imgUrl: '',
      ajaxSendMsgCode: this.ajaxGetMsgCode,
      show: false,
      phoneIsOk: false,
      time: 5
    };
  },
  computed: {
    nowStepBtn() {
      return this.steps[this.nowStep] && this.steps[this.nowStep]['nextBtn'];
    },
    diaLogTitle(step) {
      return step => {
        const arr = ['验证手机', '重置密码', '修改成功'];
        return arr[step] || '修改成功';
      };
    },
    confirmText() {
      return this.nowStep < 2 ? '下一步' : '确认';
    },
    hideBtn() {
      return this.nowStep > 1;
    }
  },
  methods: {
    initFormData(dataArr) {
      const obj = {};
      const modelObj = {};
      dataArr.forEach(item => {
        const modelObjPre = modelObj[item.step] || {};
        modelObjPre[item.key] = item.val;
        if (obj[item.step]) {
          obj[item.step].push(item);
        } else {
          obj[item.step] = [item];
        }
        modelObj[item.step] = modelObjPre;
      });
      for (let i in obj) {
        this.$set(this.form, parseInt(i), obj[i]);
        this.$set(this.modelForm, parseInt(i), modelObj[i]);
      }
      this.show = true;
    },
    back() {
      const nowStep = parseInt(this.nowStep);
      const that = this;
      if (nowStep > 0) {
        this.$confirm('是否放弃重置密码操作')
          .then(() => {
            that.$router.back();
          })
          .catch(() => {});
        return;
      }
      that.$router.back();
    },
    clearValidate() {
      this.$refs['ruleForm'].clearValidate();
    },
    backStep() {
      this.clearValidate();
      this.nowStep = this.nowStep - 1;
    },
    nextStep(step = 1) {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.show = false;
          this.nowStep = this.nowStep + step;
          setTimeout(() => {
            this.show = true;
          }, 50);
          this.clearValidate();
        } else {
          return false;
        }
      });
    },
    changeEwm(phone) {
      //更换二维码
      this.imgUrl = `${this.ajaxGetImgCode}?phone=${phone}&v=${+new Date()}`;
    },
    reviseSuccess() {
      return;
      // localStorage.clear();
      // sessionStorage.clear();
      // const timer = setInterval(() => {
      //   this.time = this.time - 1;
      //   if (this.time <= 0) {
      //     clearInterval(timer);
      //     this.$router.replace({
      //       path: '/login'
      //     });
      //   }
      // }, 1000);
    },
    callback(type) {
      if (type == 'success') {
        this.nextStep();
      } else {
        this.$emit('close');
      }
    }
  },
  created() {
    this.initFormData(this.formAllData);
  },
  beforeDestroy() {},
  filters: {}
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.revise-password {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background: #fff;
  .revise-password-dialog-body {
    width: 100%;
  }
  .step-block {
    cursor: default;
    user-select: none;
    width: 700px;
    margin-top: 120px;
    margin-bottom: 40px;
  }
  .revise-password-form {
    width: 100%;
    .yzm-img {
      width: 104px;
      img {
        width: 104px;
        height: 42px;
      }
    }
    .send-msg {
      width: 104px;
      height: 42px;
    }
    .el-form-item {
      margin-bottom: 35px;
      .input {
        border: none;
        height: 52px;
      }
    }
  }
  .revise-success {
    .icon {
      width: 128px;
      height: 128px;
    }
    .text {
      font-size: 18px;
      font-weight: bold;
      color: rgba(0, 0, 0, 1);
      line-height: 20px;
      margin-top: 15px;
      letter-spacing: 1px;
    }
    .tips {
      font-size: 14px;
      font-weight: 400;
      color: rgba(191, 191, 191, 1);
      line-height: 14px;
      margin-top: 30px;
      letter-spacing: 1px;
    }
  }
}
</style>
<style lang="scss">
.revise-password {
  .el-input-group__append {
    padding: 0;
  }
  .revise-password-dialog {
    border-radius: 12px;
    .el-dialog__header {
      padding-top: 30px;
    }
  }
  .el-input__inner {
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
  }
  .el-input__prefix {
    .el-input__icon {
      font-size: 20px;
    }
  }
  .el-input--prefix .el-input__inner {
    padding-left: 40px;
    height: 52px;
  }
  .el-input-group__append {
    background: none;
    border: none;
    position: absolute;
    right: 0;
    top: 5px;
    width: 104px;
    height: 42px;
  }
}
</style>
